$ = jQuery;
// $(function() {
  
// });
$(document).ready(function() {
  if (document.querySelector('.lazy')) { 
    $('.lazy').lazy();
  }
  window.onscroll = function() {myFunction()};

// Get the header
var header = document.getElementsByTagName("header")[0];

// Get the offset position of the navbar
var sticky = header.offsetTop;

// Add the sticky class to the header when you reach its scroll position. Remove "sticky" when you leave the scroll position
function myFunction() {
  if (window.pageYOffset > sticky) {
    header.classList.add("sticky");
  } else {
    header.classList.remove("sticky");
  }
}

$(".axis-anchor").on('click',function () {
  if (window.innerWidth > 768) {
    $(".axis-anchor").attr('aria-expanded',false);
    $(this).attr('aria-expanded',true);
    $(".axis-content").removeClass('show');
    $(".axis-content").hide();
    
    var sd = $(this).attr('data-target');
    $(sd).toggle();
  } else {
    
    $(".axis-content").slideUp();
    $(this).next().slideDown();

    setTimeout(() => {
      $('html, body').animate({
        scrollTop: $(this).offset().top - 100
      }, 500);
    }, 500);
  }
});


$(".axis-anchor-tab").on('click',function () {

  $(".axis-anchor-tab").removeClass('active');
  $(this).addClass('active');
  $(".myGroup-details").addClass('hide');
  $gid = $(this).data("target");
  $($gid).removeClass('hide');
  $(".axis-anchor-tab").attr('aria-expanded',false);
  $(this).attr('aria-expanded',true);

  $($gid).find(".axis-anchor").attr('aria-expanded',false);
  $($gid).find(".axis-anchor:first").attr('aria-expanded',true);
  $($gid).find(".axis-content").removeClass('show');
  $($gid).find(".axis-content:first").addClass('show');
  });
});

var lastScrollTop = 0;

$(window).scroll(function(event){

   var st = $(this).scrollTop();

   if (st > lastScrollTop){
      $('header').addClass('down');
      $('header').removeClass('up');
   } else {
      $('header').removeClass('down');
      $('header').addClass('up');
   }

lastScrollTop = st;

});


$(window).load(function() {
  $('#customvariantchoose .contentRadioVar').click(function() {
    $("#customvariantchoose .contentRadioVar").removeClass("active");
    $(this).addClass('active');
  });
});

// Recurpay to hanldle hide and show of add to cart options

/*************************************************
 * RECURPAY – TRADUCTIONS + FIX PRIX TRONQUÉ
 *************************************************/

window.addEventListener("DOMContentLoaded", function () {

  /* -------------------------------------------
      1) Détection langue Shopify
  ------------------------------------------- */
  const lang = (document.documentElement.getAttribute("lang") || "")
    .toLowerCase()
    .split("-")[0];

  /* -------------------------------------------
      2) Dictionnaire
  ------------------------------------------- */
  const TEXTS = {
  en: {
    subLabel: "Monthly subscription",
    subTitle:
      "- Save with the subscription: <b>-15% discount + free shipping</b><br>" +
      "- <b>Never miss a day of your cure thanks to the subscription</b><br>" +
      "No need to think about it every month anymore — we handle the orders and shipping for you.<br>" +
      "- <b>Pay monthly</b><br>" +
      "- <b>Minimum subscription period is only 3 months.</b> After this period, you are free to cancel or pause your subscription at any moment, with no additional commitment and complete simplicity.<br>" +
      "This is our guarantee to ensure you enjoy your cure with total peace of mind!<br>" +
      "<span class='rp-price-line'></span>",
    desc: "Your cure delivered every month with total peace of mind.",
    oneTimeTitle: "One-time purchase",
    freqLabel: "Delivery every month",
    btn: "Subscribe now",
    recTag: "Recommended",
    offerOnetime: "Subscribe and enjoy",
    offerAppliedLeft: "Offer applied",
    offerAppliedRight: "View applied offers",
    savingEveryMonth: (amount) => "Save " + amount + " every month"
  },


    de: {
      subLabel: "Monatliches Abonnement",
      subTitle:
        "- Sparen Sie mit dem Abo: <b>-15 % Rabatt + kostenloser Versand</b><br>" +
        "- <b>Keinen Tag Ihrer Kur verpassen dank des Abonnements</b><br>" +
        "Sie müssen nicht mehr jeden Monat daran denken – wir übernehmen die Bestellungen und den Versand für Sie.<br>" +
        "- <b>Monatlich zahlen</b><br>" +
        "- <b>Mindestlaufzeit nur 3 Monate.</b> Nach diesem Zeitraum können Sie Ihr Abonnement jederzeit kündigen oder pausieren – ohne zusätzliche Verpflichtung und ganz einfach.<br>" +
        "Das ist unsere Garantie, damit Sie Ihre Kur in voller Ruhe genießen können!<br>" +
        "<span class='rp-price-line'></span>",
      desc: "Ihre Kur wird jeden Monat zuverlässig und sorgenfrei geliefert.",
      oneTimeTitle: "Einmaliger Kauf",
      freqLabel: "Lieferung jeden Monat",
      btn: "Jetzt abonnieren",
      recTag: "Empfohlen",
      offerOnetime: "Abonnieren und profitieren",
      offerAppliedLeft: "Angebot angewendet",
      offerAppliedRight: "Angewendete Angebote ansehen",
      savingEveryMonth: (amount) => "Sparen Sie " + amount + " pro Monat"
    },

    fr: {
      subLabel: "Abonnement mensuel",
      subTitle:
        "- Faites des économies avec l’abonnement : <b>-15% de réduction + frais de port offert</b><br>" +
        "- <b>Ne ratez pas un jour de votre cure grâce à l’abonnement</b><br>" +
        "Plus besoin d’y penser chaque mois, nous gérons les commandes et envois pour vous<br>" +
        "- <b>Payez mensuellement</b><br>" +
        "- <b>Durée minimale de souscription seulement 3 mois.</b> Passé ce délai, vous êtes libre d’annuler ou mettre en pause votre abonnement à tout moment, sans engagement supplémentaire et en toute simplicité.<br>" +
        "C’est notre garantie pour que vous profitiez de votre cure en toute tranquillité !<br>" +
        "<span class='rp-price-line'></span>",
      desc: "Votre cure livrée sans interruption et gérée automatiquement pour vous.",
      oneTimeTitle: "Achat unique",
      freqLabel: "Livraison chaque mois",
      btn: "S’abonner maintenant",
      recTag: "Recommandé",
      offerOnetime: "Abonnez-vous et profitez",
      offerAppliedLeft: "Offre appliquée",
      offerAppliedRight: "Voir les offres appliquées",
      savingEveryMonth: (amount) => "Économisez " + amount + " par mois"
    }
  };

  const dict = TEXTS[lang];
  if (!dict) return;

  /* -------------------------------------------
      3) Utilitaires
  ------------------------------------------- */
  function getRoot() {
    return document.querySelector(".recurpay-pdp-widget");
  }

  function safeHTML(node, html) {
    if (!node) return;
    node.innerHTML = html;
  }

  window.__recurpayTranslating = false;

  /* -------------------------------------------
      4) Traduction principale + FIX prix
  ------------------------------------------- */
  function translate() {
    const root = getRoot();
    if (!root) return false;

    const mainTitle = root.querySelector(".recurpay__group_main_title");
    if (!mainTitle) return false;

    window.__recurpayTranslating = true;

    // TITRES
    mainTitle.textContent = dict.subLabel;
    safeHTML(root.querySelector(".recurpay__group_subtitle"), dict.subTitle);

    const oneTime = root.querySelector('[data-type="onetime-purchase"] .recurpay__group_title');
    if (oneTime) oneTime.textContent = dict.oneTimeTitle;

    const freq = root.querySelector(".recurpay__frequency_label_title");
    if (freq) freq.textContent = dict.freqLabel;

    const desc = root.querySelector(".recurpay__description p");
    if (desc) desc.innerHTML = dict.desc;

    const btn = root.querySelector("button[data-recurpay-action]");
    if (btn) btn.textContent = dict.btn;

    const rec = root.querySelector(".recommended_frequency_tag span");
    if (rec) rec.textContent = dict.recTag;

    const offerOne = root.querySelector(".recurpay__offer_message_onetime span:first-child");
    if (offerOne) offerOne.textContent = dict.offerOnetime;

    // FIX PRIX TRONQUÉ — affiche le prix sur une nouvelle ligne
    const priceOriginal = root.querySelector(".recurpay__price_compare");
    const priceFinal = root.querySelector(".recurpay__price_final");
    const priceSlot = root.querySelector(".recurpay__group_subtitle .rp-price-line");

    if (priceOriginal && priceFinal && priceSlot) {
      priceSlot.innerHTML =
        "<br>" + priceOriginal.outerHTML + " " + priceFinal.outerHTML + "<br>";
    }

    // Économies mensuelles
    const savingLine = root.querySelector(".recurpay__offer_message_subscription span:first-child");
    if (savingLine) {
      const amountEl = savingLine.querySelector(".recurpay__saving_amount");
      if (amountEl) {
        savingLine.innerHTML = dict.savingEveryMonth(amountEl.outerHTML);
      }
    }

    window.__recurpayTranslating = false;
    return true;
  }

  /* -------------------------------------------
      5) Observer
  ------------------------------------------- */
  const observer = new MutationObserver(() => {
    if (!window.__recurpayTranslating) translate();
  });

  function startObserver() {
    const container = document.querySelector(".recurpay__widget_container");
    if (container) observer.observe(container, { childList: true });
  }

  /* -------------------------------------------
      6) Retry jusqu’à prêt
  ------------------------------------------- */
  let tries = 0;
  const wait = setInterval(() => {
    tries++;
    if (translate()) {
      clearInterval(wait);
      startObserver();
    }
    if (tries > 50) clearInterval(wait);
  }, 300);

});





/*************************************************
 * RECURPAY – RADIO BUTTON LOGIC (fix no-loop)
 *************************************************/
$(document).ready(function () {

  function handleAddToCartButton() {
    const one = document.querySelector('.recurpay__onetime_radio[value="one-time"]');
    const sub = document.querySelector('.recurpay__subscribe_radio[value="subscription"]');

    if (one?.checked) $(".products__ge--details--price").show();
    else if (sub?.checked) $(".products__ge--details--price").hide();
  }

  const inner = document.querySelector(".recurpay__widget_container");

  if (inner) {
    new MutationObserver((mut) => {
      if (window.__recurpayTranslating) return;

      mut.forEach(m => {
        if (m.type === "attributes" && m.attributeName === "class") {
          const t = m.target;
          if (
            t.classList.contains("recurpay__widget_container--selected") &&
            t.querySelector('input[type="radio"]')?.checked
          ) {
            handleAddToCartButton();
          }
        }
      });
    }).observe(inner, {
      attributes: true,
      attributeFilter: ["class"]
    });
  }

  document.addEventListener("recurpay:init", handleAddToCartButton);

});
